// StatusDot primitive — port of design/v3/Primitives.jsx:97-103 (online/offline dot).
// 확장: tone(success/warning/danger/info/muted) + size(sm/md). 시안 패턴은 success/muted 두 톤.

import type { CSSProperties } from 'react';

export type StatusDotTone = 'success' | 'warning' | 'danger' | 'info' | 'muted';
export type StatusDotSize = 'sm' | 'md';

const toneColor: Record<StatusDotTone, string> = {
  success: 'var(--success)',
  warning: 'var(--warning)',
  danger: 'var(--danger)',
  info: 'var(--info)',
  muted: 'var(--fg-4)',
};

const sizePx: Record<StatusDotSize, number> = {
  sm: 6,
  md: 8,
};

export interface StatusDotProps {
  tone?: StatusDotTone;
  size?: StatusDotSize;
  style?: CSSProperties;
}

export function StatusDot({ tone = 'success', size = 'md', style }: StatusDotProps) {
  const dim = sizePx[size];
  return (
    <span
      aria-hidden
      style={{
        width: dim,
        height: dim,
        borderRadius: 'var(--radius-full)',
        background: toneColor[tone],
        display: 'inline-block',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
